// extracted by mini-css-extract-plugin
export default {"root":"classes_root__ojJzx","label":"classes_label__NOUB9","radio-button":"classes_radio-button__fJMxh","label-typo":"classes_label-typo__Ve6YG"};